module.exports = __webpack_public_path__ + "img/KM211.218.630b4378.png";